module.exports = __webpack_public_path__ + "img/emoji_31.993be7df.png";